import { useMutation } from '@apollo/client'
import { EditEventAttendeeInsurance, EditEventAttendeeInsuranceVariables } from '../../types'
import { EDIT_EVENT_ATTENDEE_INSURANCE } from './operations'

export const useEditEventAttendeeInsurance = () =>
  useMutation<EditEventAttendeeInsurance, EditEventAttendeeInsuranceVariables>(
    EDIT_EVENT_ATTENDEE_INSURANCE
  )
